export default "__VITE_ASSET__QcWpECKB__"